import type { Story } from '@/store/story-types'

export const BEAUTY_PICKS_STORE_STORY: Story = {
  id: 'beauty-picks-store',
  name: 'Beauty Picks Store',
  narrative: 'A K-Beauty creator store with curated skincare collections, product reviews, and seamless checkout for beauty enthusiasts.',
  goals: ['Browse curated beauty collections', 'View product details and reviews', 'Manage shopping cart', 'Complete checkout with shipping'],
  lifecycle: 'building',
  pages: [
    {
      id: 'pg-home', title: 'Home', order: 0, status: 'draft', elementCount: 5, linkedPageId: 'home',
      description: 'Landing page with navbar, hero banner, bestseller grid, reviews section, and footer',
      blockRef: { category: 'beauty', blockId: 'beauty-hero' },
    },
    {
      id: 'pg-product-detail', title: 'Product Detail', order: 1, status: 'draft', elementCount: 3, linkedPageId: 'product-detail',
      description: 'Product detail page with images, description, reviews, and add-to-cart action',
      blockRef: { category: 'beauty', blockId: 'product-detail-beauty' },
    },
    {
      id: 'pg-cart', title: 'Cart', order: 2, status: 'draft', elementCount: 3, linkedPageId: 'cart',
      description: 'Shopping cart with item list, quantity controls, and subtotal',
      blockRef: { category: 'beauty', blockId: 'cart-view' },
    },
    {
      id: 'pg-checkout', title: 'Checkout', order: 3, status: 'draft', elementCount: 3, linkedPageId: 'checkout',
      description: 'Checkout page with shipping address, payment method, and order confirmation',
      blockRef: { category: 'beauty', blockId: 'checkout' },
    },
  ],
  bddScenarios: [
    {
      id: 'bdd-1',
      name: 'Browse Beauty Picks',
      description: 'Visitor browses curated beauty products on the home page',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'the page loads' },
        { type: 'then', text: 'a hero banner, bestseller grid, and reviews section are visible', linkedPageId: 'home' },
      ],
    },
    {
      id: 'bdd-2',
      name: 'View Product Detail',
      description: 'Visitor taps a product to see details and reviews',
      steps: [
        { type: 'given', text: 'the visitor is on the home page' },
        { type: 'when', text: 'they tap a product card' },
        { type: 'then', text: 'the product detail page shows images, description, and an add-to-cart button', linkedPageId: 'product-detail' },
      ],
    },
    {
      id: 'bdd-3',
      name: 'Add to Cart',
      description: 'Visitor adds a beauty product to the cart',
      steps: [
        { type: 'given', text: 'the visitor is on the product detail page', linkedPageId: 'product-detail' },
        { type: 'when', text: 'they tap the Add to Cart button' },
        { type: 'then', text: 'the cart badge updates and the item appears in the cart', linkedPageId: 'cart' },
      ],
    },
    {
      id: 'bdd-4',
      name: 'Complete Checkout',
      description: 'Visitor completes checkout with shipping and payment',
      steps: [
        { type: 'given', text: 'the visitor has items in the cart', linkedPageId: 'cart' },
        { type: 'when', text: 'they proceed to checkout' },
        { type: 'then', text: 'a checkout form with shipping and payment fields is displayed', linkedPageId: 'checkout' },
        { type: 'and', text: 'the form validates inputs before order submission', linkedFlowId: 'validateCheckout' },
      ],
    },
  ],
}
